import React from "react";
import styles from "./Button.module.css";

export default function Button({
  children,
  variant = "primary", // primary | secondary | ghost | outline | danger
  size = "md", // sm | md | lg
  fullWidth = false,
  loading = false,
  disabled = false,
  leftIcon = null,
  rightIcon = null,
  type = "button",
  className = "",
  onClick,
  ...rest
}) {
  const isDisabled = disabled || loading;

  const classes = [
    styles.button,
    styles[variant || "primary"],
    styles[size || "md"],
    fullWidth ? styles.fullWidth : "",
    loading ? styles.loading : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={isDisabled}
      {...rest}
    >
      <span className={styles.inner}>
        {loading ? (
          <span className={styles.spinner} aria-hidden="true" />
        ) : leftIcon ? (
          <span className={styles.iconSlot}>{leftIcon}</span>
        ) : null}

        <span className={styles.label}>{children}</span>

        {!loading && rightIcon ? (
          <span className={styles.iconSlot}>{rightIcon}</span>
        ) : null}
      </span>
    </button>
  );
}